// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "registry/v1/registry.proto" (package "registry.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RegistryService } from "./registry";
import type { GetRegistryItemVersionDocsResponse } from "./registry";
import type { GetRegistryItemVersionDocsRequest } from "./registry";
import type { GetMachinePartBestModuleVersionResponse } from "./registry";
import type { GetMachinePartBestModuleVersionRequest } from "./registry";
import type { ListAllRegistryItemsResponse } from "./registry";
import type { ListAllRegistryItemsRequest } from "./registry";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetRegistryItemUsageResponse } from "./registry";
import type { GetRegistryItemUsageRequest } from "./registry";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * RegistryService is used to manage Modules, ML Models, etc in the Viam Registry.
 * This service is for internal usage only and is not guaranteed to be backwards compatible.
 *
 * @generated from protobuf service registry.v1.RegistryService
 */
export interface IRegistryServiceClient {
    /**
     * GetRegistryItemUsage
     * - returns details on each machine using a registry item (currently limited to modules)
     * - permissions branch on the request:
     *   - when organization_id is unset, the caller must be a viam employee and
     *     usage is returned across the entire Viam fleet
     *   - when organization_id is set, the caller must have read access to that
     *     org and usage is filtered to parts the org can reach (its primary org
     *     and locations shared into it)
     *
     * @generated from protobuf rpc: GetRegistryItemUsage(registry.v1.GetRegistryItemUsageRequest) returns (registry.v1.GetRegistryItemUsageResponse);
     */
    getRegistryItemUsage(input: GetRegistryItemUsageRequest, options?: RpcOptions): UnaryCall<GetRegistryItemUsageRequest, GetRegistryItemUsageResponse>;
    /**
     * ListAllRegistryItems
     * - for viam employees only
     * - returns a list of all registry items regardless of visibility
     *
     * @generated from protobuf rpc: ListAllRegistryItems(registry.v1.ListAllRegistryItemsRequest) returns (registry.v1.ListAllRegistryItemsResponse);
     */
    listAllRegistryItems(input: ListAllRegistryItemsRequest, options?: RpcOptions): UnaryCall<ListAllRegistryItemsRequest, ListAllRegistryItemsResponse>;
    /**
     * GetMachinePartBestModuleVersion
     * - returns the best semver for a module based on the part's associated hardware and chosen version specification
     *
     * @generated from protobuf rpc: GetMachinePartBestModuleVersion(registry.v1.GetMachinePartBestModuleVersionRequest) returns (registry.v1.GetMachinePartBestModuleVersionResponse);
     */
    getMachinePartBestModuleVersion(input: GetMachinePartBestModuleVersionRequest, options?: RpcOptions): UnaryCall<GetMachinePartBestModuleVersionRequest, GetMachinePartBestModuleVersionResponse>;
    /**
     * GetRegistryItemVersionDocs
     * - returns documentation for a single version of a registry item
     *
     * @generated from protobuf rpc: GetRegistryItemVersionDocs(registry.v1.GetRegistryItemVersionDocsRequest) returns (registry.v1.GetRegistryItemVersionDocsResponse);
     */
    getRegistryItemVersionDocs(input: GetRegistryItemVersionDocsRequest, options?: RpcOptions): UnaryCall<GetRegistryItemVersionDocsRequest, GetRegistryItemVersionDocsResponse>;
}
/**
 * RegistryService is used to manage Modules, ML Models, etc in the Viam Registry.
 * This service is for internal usage only and is not guaranteed to be backwards compatible.
 *
 * @generated from protobuf service registry.v1.RegistryService
 */
export class RegistryServiceClient implements IRegistryServiceClient, ServiceInfo {
    typeName = RegistryService.typeName;
    methods = RegistryService.methods;
    options = RegistryService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * GetRegistryItemUsage
     * - returns details on each machine using a registry item (currently limited to modules)
     * - permissions branch on the request:
     *   - when organization_id is unset, the caller must be a viam employee and
     *     usage is returned across the entire Viam fleet
     *   - when organization_id is set, the caller must have read access to that
     *     org and usage is filtered to parts the org can reach (its primary org
     *     and locations shared into it)
     *
     * @generated from protobuf rpc: GetRegistryItemUsage(registry.v1.GetRegistryItemUsageRequest) returns (registry.v1.GetRegistryItemUsageResponse);
     */
    getRegistryItemUsage(input: GetRegistryItemUsageRequest, options?: RpcOptions): UnaryCall<GetRegistryItemUsageRequest, GetRegistryItemUsageResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRegistryItemUsageRequest, GetRegistryItemUsageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListAllRegistryItems
     * - for viam employees only
     * - returns a list of all registry items regardless of visibility
     *
     * @generated from protobuf rpc: ListAllRegistryItems(registry.v1.ListAllRegistryItemsRequest) returns (registry.v1.ListAllRegistryItemsResponse);
     */
    listAllRegistryItems(input: ListAllRegistryItemsRequest, options?: RpcOptions): UnaryCall<ListAllRegistryItemsRequest, ListAllRegistryItemsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAllRegistryItemsRequest, ListAllRegistryItemsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetMachinePartBestModuleVersion
     * - returns the best semver for a module based on the part's associated hardware and chosen version specification
     *
     * @generated from protobuf rpc: GetMachinePartBestModuleVersion(registry.v1.GetMachinePartBestModuleVersionRequest) returns (registry.v1.GetMachinePartBestModuleVersionResponse);
     */
    getMachinePartBestModuleVersion(input: GetMachinePartBestModuleVersionRequest, options?: RpcOptions): UnaryCall<GetMachinePartBestModuleVersionRequest, GetMachinePartBestModuleVersionResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMachinePartBestModuleVersionRequest, GetMachinePartBestModuleVersionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetRegistryItemVersionDocs
     * - returns documentation for a single version of a registry item
     *
     * @generated from protobuf rpc: GetRegistryItemVersionDocs(registry.v1.GetRegistryItemVersionDocsRequest) returns (registry.v1.GetRegistryItemVersionDocsResponse);
     */
    getRegistryItemVersionDocs(input: GetRegistryItemVersionDocsRequest, options?: RpcOptions): UnaryCall<GetRegistryItemVersionDocsRequest, GetRegistryItemVersionDocsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRegistryItemVersionDocsRequest, GetRegistryItemVersionDocsResponse>("unary", this._transport, method, opt, input);
    }
}
